import { Cookie } from '~/services';
import { API_ENDPOINTS, COOKIE_KEYS } from '~/constants';
import { getType, isValidJSON, isValidURL } from '~/utils';

type RequestBody = {
  url: string;
  start: number;
  stop: number;
  duration: number;
  cookie: Partial<ReturnType<typeof Cookie.getCookieArray>>;
};

export default defineNuxtPlugin(() => {
  const start = () => {
    const { href } = useRequestURL();

    const activity: Pick<RequestBody, 'url' | 'start'> = {
      url: href,
      start: Date.now(),
    };

    Cookie.set(COOKIE_KEYS.ACTIVITY, JSON.stringify(activity));
  };

  const send = async (body: RequestBody) => {
    const {
      public: { api_app: baseURL },
    } = useRuntimeConfig();

    try {
      await $fetch(API_ENDPOINTS.ACTIVITY, {
        method: 'POST',
        baseURL,
        body,
        credentials: 'include',
      });
    } catch (error) {
      debug('Activity.send', error);
    }
  };

  const end = () => {
    const pureActivityFromCookie = Cookie.get(COOKIE_KEYS.ACTIVITY);

    if (isValidJSON(pureActivityFromCookie)) {
      const parsedActivityFromCookie: unknown = JSON.parse(
        pureActivityFromCookie,
      );

      if (
        getType(parsedActivityFromCookie) === 'Object' &&
        getType(parsedActivityFromCookie.start) === 'Number' &&
        isValidURL(parsedActivityFromCookie.url)
      ) {
        const stop = Date.now();
        const { url, start } = parsedActivityFromCookie as Pick<
          RequestBody,
          'url' | 'start'
        >;

        const activity: RequestBody = {
          url,
          start,
          stop,
          duration: (stop - start) / 1000,
          cookie: Cookie.getCookieArray(),
        };

        void send(activity);
      } else {
        debug('Activity.end', 'invalid activity');
      }
    }

    Cookie.delete(COOKIE_KEYS.ACTIVITY);
  };

  return {
    provide: {
      activity: {
        start,
        end,
      },
    },
  };
});
